import React, { startTransition } from "react";

import history from "./history";

type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  /**
   * The URL to navigate to
   */
  href: string;
  /**
   * Whether to open the link in a new tab
   */
  external?: boolean;
  /**
   * Child elements to render inside the link
   */
  children?: React.ReactNode;
};

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ external, ...props }, ref) => {
    const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();

      if (typeof props.onClick === "function") {
        props.onClick(e);
      }

      if (external) {
        window.open(props.href, "_blank")?.focus();
      } else {
        startTransition(() => history.push(props.href));
      }
    };

    return (
      <a {...props} ref={ref} onClick={onClick}>
        {props.children}
      </a>
    );
  },
);

Link.displayName = "Link";

export default Link;
